import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceSettings } from "../../../../features/settings/workspace/workspace-settings";

export const Route = createFileRoute("/w/$slug/settings/workspace")({
  component: WorkspaceSettings,
});
